import { styled, FormLabel, formLabelClasses } from "@mui/material";
const RadioFormLabel = styled(FormLabel)(({ theme, required }) => ({
  display: "block",
  ...theme.typography["Lato Body 1"],
  color: theme.palette.grey[800],
  marginBottom: theme.spacing(2),
  [`& .${formLabelClasses.asterisk}`]: {
    display: "none"
  },
  "&.Mui-error": {
    color: theme.palette.error[500]
  },
  "&.Mui-focused:not(.Mui-error)": {
    color: theme.palette.grey[800]
  },
  "&::before": {
    content: required ? "'*'" : void 0,
    color: theme.palette.error[500]
  }
}));
export {
  RadioFormLabel
};
